/**
 * @type {Object} scoutConfig - Scout 配置信息
 * @property {string} [scoutConfig.projectName=common_sensors] - BI 定义的项目名，默认使用公共埋点项目的项目名
 * @property {string} [appKey.appKey] - 仓储项目名，默认使用 pacakage.name
 * @property {Map<string, string>} pageNames.pageNames - key 是 pageCode，value 是 pageAbsolutePath
 */
const scoutConfig = {
  projectName: 'common_sensors',
  appKey: 'hready-public-web',
  pageNames: {},
};

export default scoutConfig;
